const modalDescription = {
  amendment: {},
  annualReport: {},
  bankingResolutionTemplate: {},
  bankOfAmericaOffer: {},
  beneficialOwnershipFiling: {
    fullScreen: true
  },
  businessDocuments: {},
  businessLicenseReport: {},
  chaseOffer: {},
  checkingPreferred: {},
  corpBusinessKit: {},
  corporateBylaws: {},
  dbaEntity: {},
  domainNamePrivacy: {},
  domainNameReg: {},
  einCreation: {},
  email: {},
  entityNameReservation: {},
  futureFileDate: {},
  grantApplication: {},
  legalShield: {},
  llcBusinessKit: {},
  logoKit: {},
  microsoft365Promo: {},
  nyPublication: {},
  ocoyaSocialMedia: {},
  onlineNotaryService: {},
  operatingAgreement: {},
  registeredAgent: {},
  standardGoodStanding: {},
  taxServices: {},
  website: {},
  websiteDuda: {},
  websiteToolsBundle: {},
  wfgInitialReport: {},
  worryFreeService: {},
  zenBusinessMoney: {}
};

const getModalDetails = (modalName, config) => {
  const modal = modalDescription[modalName];
  return modal instanceof Function ? modal(config) : modal;
};

export const allowedModals = Object.keys(modalDescription);

export default getModalDetails;
